import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><path d="M14.5 5L8 11.5 1.4 5z" stroke-linecap="round" fill="currentcolor" stroke-linejoin="round"/></svg>`;

export { symbol as default };
